import { __rest, __assign } from 'tslib';
import CircularProgress from '@mui/material/CircularProgress';
import MuiIconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import React from 'react';

var ProgressWrapper = styled('div')({
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
});
var IconButton = React.forwardRef(function IconButton(_a, ref) {
    var children = _a.children, _b = _a.loading, loading = _b === void 0 ? false : _b, restProps = __rest(_a, ["children", "loading"]);
    return (React.createElement(MuiIconButton, __assign({}, restProps, { ref: ref }),
        children,
        loading && (React.createElement(ProgressWrapper, null,
            React.createElement(CircularProgress, { color: "inherit", size: "100%" })))));
});

export { IconButton as default };
